import DetailImage from './DetailImage';

export default DetailImage;
